const ITEMS = [
  "Hukum Pidana",
  "Hukum Perdata",
  "Hukum Keluarga & Waris",
  "Pertanahan & Agraria",
  "Ketenagakerjaan",
  "Hukum Perusahaan",
  "Bantuan Hukum Pro Bono",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <div key={item} className="flex items-center">
        <span className="whitespace-nowrap px-10 font-serif text-2xl italic text-[#F5F5F5]/75 md:text-4xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" aria-hidden="true" />
      </div>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="practice-marquee"
    className="relative overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-8"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
